export default __webpack_public_path__ + "static/media/MSExcel.f7b3707c.png";